import { Core } from "@faire/design-tokens";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import isEmpty from "lodash/isEmpty";
import React from "react";
import styled from "styled-components";

import { useListOfSelectedNodes } from "../hooks/useListOfSelectedNodes";

export const SelectedIssuesBulletedListCard: React.FC = () => {
  const { selectedNodes } = useListOfSelectedNodes();
  return (
    <>
      {selectedNodes[0]?.label ? (
        <>
          <Typography variant="paragraphSansMedium">
            {selectedNodes[0].sidebarTitle ?? selectedNodes[0].label}
          </Typography>
          <Spacer height="1x" />
        </>
      ) : null}
      {!isEmpty(selectedNodes)
        ? selectedNodes.map((selectedNode) => {
            if (selectedNode.id === selectedNodes[0]?.id) {
              return;
            }
            return (
              <LineItem key={selectedNode.id}>{selectedNode.label}</LineItem>
            );
          })
        : null}
    </>
  );
};

const LineItem = styled(Typography)`
  &::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
    margin-left: 8px;
    background-color: ${Core.surface.default};
    vertical-align: middle;
    display: inline-block;
  }
`;
